module.exports = __webpack_public_path__ + "static/media/ivana.59878066.JPG";